import React from 'react';
import { URL } from 'appConstants';
import MediaShell from '../MediaShell';
import MediaV4List from '../MediaV4List';

const MediaSpecialProjects = () => (
  <MediaShell
    title="Внешние мероприятия"
    crumbCurrent="Внешние мероприятия"
  >
    <MediaV4List
      requestUrl={URL.NEWS.SPECPROJECTS.GET}
      badge="МЕРОПРИЯТИЯ"
      action="external"
    />
  </MediaShell>
);

export default MediaSpecialProjects;
